export const getActiveCriteriaCount = criteria => criteria.filter(criterion => criterion.isActive).length
